<template>
  <v-col cols="12" class="breadcrumb-inner ma-0 pb-0">
    <nav aria-label="breadcrumb">
      <ol
        class="breadcrumb"
        :class="{ 'our-solutions': ourSolutions, isArticle: isArticle }"
      >
        <v-icon small class="mr-2">{{ icons.mdiArrowLeft }}</v-icon>
        <li
          class="breadcrumb-item"
          v-for="(crumb, index) in breadcrumbs"
          :key="index"
          :class="{ active: isActive(crumb.path) }"
        >
          <router-link
            v-if="index < breadcrumbs.length - 1"
            :to="crumb.path"
            :class="{ 'no-underline': true }"
          >
            {{ decodeURIComponent(crumb.name) }}
          </router-link>
          <span v-else :class="{ 'no-underline': true }">
            {{ decodeURIComponent(crumb.name) }}
          </span>
          <span
            v-if="index < breadcrumbs.length - 1"
            class="breadcrumb-separator"
            >/</span
          >
        </li>
      </ol>
    </nav>
  </v-col>
</template>

<script>
import { mdiArrowLeft } from "@mdi/js";
export default {
  name: "Breadcrumb",
  data() {
    return {
      icons: {
        mdiArrowLeft: mdiArrowLeft,
      },
    };
  },
  props: {
    isArticle: {
      required: false,
      default: false,
      type: Boolean,
    },
    ourSolutions: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    breadcrumbs() {
      let pathArray = this.$route.path.split("/").filter((p) => p);
      let breadcrumbs = pathArray.map((path, index) => {
        let fullPath = "/" + pathArray.slice(0, index + 1).join("/");
        let route = this.$router.options.routes.find(
          (route) => route.path === fullPath
        );
        return {
          name: this.breadcrumbName(route ? route.name : path),
          path: fullPath,
        };
      });
      return [{ name: this.breadcrumbName("Home"), path: "/" }, ...breadcrumbs];
    },
  },
  methods: {
    breadcrumbName(crumbName) {
      if (crumbName === "FAQs") {
        return crumbName
          .replace(/^./, (str) => str.toUpperCase())
          .replace(/-/g, " ")
          .replace(/\s+./g, (str) => str.toUpperCase())
          .trim();
      } else {
        return crumbName
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase())
          .replace(/-/g, " ")
          .replace(/\s+./g, (str) => str.toUpperCase())
          .trim();
      }
    },
    isActive(path) {
      return this.$route.path === path;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.breadcrumb-inner {
  padding-left: 0;
}
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  padding-top: 50px;
  margin-bottom: 60px;
  .breadcrumb-item {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  * {
    color: black;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.1px;
  }
  &.isArticle {
    margin-bottom: 0 !important;
  }
}
.breadcrumb-item + .breadcrumb-item {
  margin-left: 0.5rem;
}
.breadcrumb-separator {
  margin-left: 8px;
}
.no-underline {
  text-decoration: none;
}
.breadcrumb-item.active .no-underline {
  font-weight: 600;
}
@media screen and (max-width: 807px) {
  .our-solutions {
    padding-top: 188px !important;
  }
}
</style>
